import { Space, SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { FC } from 'react';
import DotLoader from '../../../../../../components/DotLoader';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import ChannelRecency from '../ChannelRecency';
import EngagementFilter from '../EngagementFilter';
import { Frequency } from '../FrequencyFilter';
import useEventFilterManager from '../hooks/useEventFilterManager';
import LinkedFilter from '../LinkedFilter';
import PageURLFilter from './PageURLFilter';
import ParamsFilter from './ParamsFilter';

const Site: FC<ICustomFilter> = ({ onChange }) => {
  const { isLoading, setIsLoading, handleChildChange } = useEventFilterManager({
    filterPrefix: 'site',
    onChange,
  });

  return (
    <SpaceVertical gap="u5" paddingX="u12" paddingTop="u5">
      <EngagementFilter
        onChange={handleChildChange}
        filterId="smart_pixel_match_type_filter"
        filterLabel="Match Type"
        matchTypeFilter
      />
      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Tag Collection</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="smart_pixel_collection_filter"
          view="genome_suggestions_hcp365_collection"
          fields={['genome_suggestions_hcp365_collection.collection_name_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_collection.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_collection.pseudo_account_id_filter"
          warningMessage="Changing Collection will affect other Collection in Engagement"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <ChannelRecency onMultiFilterChange={handleChildChange} paddingX="none" />
      <PageURLFilter onChange={handleChildChange} />
      <ParamsFilter onChange={handleChildChange} />
      <Space align="stretch" paddingBottom="u5">
        <Frequency
          onChange={handleChildChange}
          filterName={'site_pageviews_filter'}
          label={'Exposed Pageviews'}
          subHeading={'Only trigger if the person browsed at least'}
          suffix={'pages'}
        />
      </Space>
    </SpaceVertical>
  );
};

export default Site;
